import * as R from 'ramda';
export const whereEquals = R.curry((partialObj, obj) => R.compose(R.where(R.__, obj), R.mapObjIndexed(R.unary(R.equals)))(partialObj));
